/* eslint-disable max-len */
import React from 'react';

export default function CancelSign() {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.02538 9.99999C2.02538 8.03645 2.74182 6.23949 3.9231 4.8486L15.1515 16.077C13.7606 17.2582 11.9636 17.9746 10.0001 17.9746C5.60259 17.9746 2.02538 14.3975 2.02538 9.99999ZM17.9746 9.99995C17.9746 11.7043 17.4324 13.282 16.5179 14.5798L5.42016 3.48197C6.71789 2.56755 8.2956 2.02527 9.99991 2.02527C14.3974 2.02527 17.9746 5.60249 17.9746 9.99995ZM10 0C4.48557 0 0 4.48607 0 10C0 15.5139 4.48557 20 10 20C15.5144 20 20 15.5139 20 10C20 4.48607 15.5144 0 10 0Z"
				fill="white"
			/>
		</svg>
	);
}
